module.exports = __webpack_public_path__ + "img/JM.8a8dbeed.svg";